import { useState } from "react";
import { useSelector } from "react-redux";
import Select, { OptionTypeBase } from "react-select";
import { ci } from "../../store/modules/CIStore";
import { request } from "../../store/modules/RequestStore";

// import noAssets from "./../../assets/images/assets.png";

import {
  Asociar,
  Asset,
  Confirm,
} from "../../components/RequestPage/TabAssets/Asset";

//scrollbar
import Scrollbar from "../../components/widgets/Scrollbar";

// dropdown
// import Dropdown, { DropdownItem } from "../../components/widgets/DropDown";
import { Modal } from "../../components/widgets/Popup";
import { useTranslation } from "react-i18next";

const TabAssets = ({
  associateCItoRequest,
  setCiToRemove,
  setModalRemoveCI,
}: any) => {
  const ciStore = useSelector(ci);
  const requestState = useSelector(request);
  const { t } = useTranslation()

  //   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [assetsCreateModalActive, setAssetsCreateModalActive] = useState(false);
  //   const [assetListToAssociate, setAssetListToAssociate] = useState([]);

  const [selectedOption, setSelectedOption] = useState<OptionTypeBase>({
    value: "",
    label: t("requestDetail.tabAssets.selectActive"),
  });

  const handleUser = (e: any) => {
    setSelectedOption(e);
  };

  const handleAssociateCI = () => {
    if (selectedOption.value !== "") {
      associateCItoRequest(selectedOption.value);
      setSelectedOption({
        value: "",
        label: t("requestDetail.tabAssets.selectActive"),
      });
    }
  };

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      display: "flex",
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      display: "none",
    }),
    indicatorsContainer: (provided: any, state: any) => ({
      ...provided,
      display: "none",
    }),
  };

  return (
    <div className="flex flex-col px-0 lg:px-8 text-sm sm:text-md">
      <Modal
        height="auto"
        active={assetsCreateModalActive}
        setModalActive={setAssetsCreateModalActive}
        // setIsDropdownOpen={setIsDropdownOpen}
      >
        <Confirm
          setModalActive={setAssetsCreateModalActive}
          options={selectedOption}
          //   setOptions={setSelectedOption}
          crear={handleAssociateCI}
        />
      </Modal>
      <div className="flex flex-row justify-between relative h-16">
        {requestState.active.StatusName !== "Cerrada" && (
          <Select
            className="rounded-md w-9/12 focus:border-azul z-10"
            defaultValue={selectedOption}
            onChange={(e) => handleUser(e)}
            options={ciStore.list}
            styles={customStyles}
          />
        )}
        {requestState.active.StatusName !== "Cerrada" && (
          <Asociar
            handleAssociateCI={handleAssociateCI}
            setModalActive={setAssetsCreateModalActive}
            selectedOption={selectedOption}
          />
        )}

        {/* <div className="flex align-center">

          <Dropdown
            setIsDropdownOpen={setIsDropdownOpen}
            isDropdownOpen={isDropdownOpen}
            setModalActive={setAssetsCreateModalActive}
            selectedOptions={assetListToAssociate}
          >
            <Scrollbar>
              <ul>
                {ciStore.list.map((item, index) => {
                  return (
                    <DropdownItem
                      item={item}
                      key={index}
                      setSelectedOptions={setAssetListToAssociate}
                      selectedOptions={assetListToAssociate}
                    />
                  );
                })}
              </ul>
            </Scrollbar>
          </Dropdown>
        </div> */}
      </div>

      {requestState.assets.length > 0 ? (
        <Scrollbar>
          <div className="w-full flex flex-col items-center gap-3 md:grid md:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:gap-4 px-3">
            {requestState.assets.map((asset, index) => {
              return (
                <Asset
                  key={index}
                  setCiToRemove={setCiToRemove}
                  setModalRemoveCI={setModalRemoveCI}
                  asset={asset}
                />
              );
            })}
          </div>
        </Scrollbar>
      ) : (
        <div className="flex flex-col items-center justify-center h-96">
          {/* <img className="w-48" src={noAssets} alt="asset" /> */}
          <p className="text-sm sm:text-md md:text-lg">
            {t("requestDetail.tabAssets.empty")}
          </p>
        </div>
      )}
    </div>
  );
};

export default TabAssets;
